//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { BodyPrimaryAnchor } from '@components/atoms/anchor/Anchor';
import Icon from '@components/atoms/icon/Icon';
import { SubtitleText } from '@components/atoms/text/Text';
import { Mixins } from '@theme/mixins';
import { FeatureCardGrid } from '@welcome-page/components/onboarding/spotlight/FeatureCardGrid';
import { ONBOARDING_TRACKING_ID } from '@welcome-page/constants/OnboardingConstants';

export const FeatureSpotlight = () => {
  return (
    <SpotlightContainer>
      <TitleContainer>
        <SubtitleText>
          Learn more about the latest and greatest features available.
        </SubtitleText>
        <SeeUpdatesAnchor
          trackingId={
            ONBOARDING_TRACKING_ID.SPOTLIGHT_SEE_ALL_RECENT_UPDATES_BUTTON
          }
          href='https://www.bazaarvoice.com/updates/'
        >
          <LinkOutIcon />
          &nbsp;See all recent updates
        </SeeUpdatesAnchor>
      </TitleContainer>
      <FeatureCardGrid />
    </SpotlightContainer>
  );
};

const SpotlightContainer = styled.div(
  ({ theme }) => `
  ${Mixins.Sheet.Low}
  display: flex;
  flex-direction: column;
  padding-top: ${theme.spacings[3]};
  padding-bottom: ${theme.spacings[3]};
  padding-left: ${theme.spacings[4]};
  padding-right: ${theme.spacings[4]};
  gap: 12px;
  box-shadow: ${theme.boxShadows[2]};
`,
);

const TitleContainer = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${theme.spacings[3]};
  text-wrap: nowrap;
`,
);

const SeeUpdatesAnchor = styled(BodyPrimaryAnchor).attrs({ target: '_blank' })(
  ({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  &&, &&:hover {
    color: ${theme.colors.teal2};
  }
`,
);

const LinkOutIcon = styled(Icon).attrs({ name: 'linkout' })`
  height: 13px;
  width: 13px;
`;
